import LicenseSingle from './LicenseSingle'

export default LicenseSingle